import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslate } from 'react-redux-multilingual'

/**
 * Modal de choix de la destination d'impression d'un ticket (réimpression avec to_prepare activé).
 * Deux cases à cocher : caisse (cochée par défaut) et préparation (décochée par défaut).
 *
 * @param {boolean} show - Contrôle la visibilité de la modal
 * @param {Function} onHide - Callback à la fermeture (annulation)
 * @param {Function} onConfirm - Callback à la validation, reçoit { caisse: boolean, preparation: boolean }
 */
const ModalTicketPrintDestination = ({ show, onHide, onConfirm }) => {
    const t = useTranslate();

    // ─── State ────────────────────────────────────────────────────────────────
    const [caisse, setCaisse] = useState(true)
    const [preparation, setPreparation] = useState(false)

    // Réinitialise les valeurs par défaut à chaque ouverture
    useEffect(() => {
        if (show) {
            setCaisse(true)
            setPreparation(false)
        }
    }, [show])

    // ─── Render ───────────────────────────────────────────────────────────────
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>{t('ticketPrintDestination')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-check mb-2">
                    <input className="form-check-input" type="checkbox" id="print-destination-caisse" checked={caisse} onChange={(e) => setCaisse(e.target.checked)} />
                    <label className="form-check-label" htmlFor="print-destination-caisse">{t('cashRegister')}</label>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="print-destination-preparation" checked={preparation} onChange={(e) => setPreparation(e.target.checked)} />
                    <label className="form-check-label" htmlFor="print-destination-preparation">{t('preparationPrinter')}</label>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-danger" onClick={onHide}>{t('btnCancel')}</button>
                {/* Au moins une destination doit être cochée */}
                <button className="btn btn-primary" disabled={!caisse && !preparation} onClick={() => onConfirm({ caisse, preparation })}>{t('btnPrint')}</button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalTicketPrintDestination;
